import { render, staticRenderFns } from "./addImportaFisaModal.vue?vue&type=template&id=3750982f"
import script from "./addImportaFisaModal.vue?vue&type=script&lang=js"
export * from "./addImportaFisaModal.vue?vue&type=script&lang=js"
import style0 from "./addImportaFisaModal.vue?vue&type=style&index=0&id=3750982f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports